<template>
  <div class="card">
    <div class="card-header pb-0">
      <div class="row">
        <div class="col-lg-6 col-7">
          <h6>{{ title }}</h6>
        </div>
      </div>
      <!-- Warning banner -->
      <div v-if="banner" class="alert alert-danger d-flex align-items-center mt-2 mb-0 py-2 px-3" role="alert">
        <i class="material-icons me-2" style="font-size:20px;">warning</i>
        <span class="text-sm">{{ banner }}</span>
      </div>
    </div>
    <div class="card-body px-0 pb-2">
      <div class="table-responsive">
        <table class="table align-items-center mb-0">
          <thead>
            <tr>
              <th v-for="(heading, index) of headers" :key="index" :class="[
                index === 1 ? 'ps-2 status-column' : '',
                index >= 3 ? 'text-center' : '',
              ]" class="text-uppercase text-secondary text-sm font-weight-bolder opacity-7">
                {{ heading }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="({ item, status, description }, index) of projects" :key="index">
              <td>
                <div class="d-flex px-2 py-1">
                  <div class="d-flex flex-column justify-content-center">
                    <p class="mb-0 text-sm text-capitalize">{{ item }}</p>
                  </div>
                </div>
              </td>
              <td class="status-column">
                <div class="d-flex flex-column justify-content-center status-badge-wrap">
                  <MaterialSelectedBadge :label="status" :color="getStatusColor(status)" />
                </div>
              </td>
              <td>
                <div class="d-flex flex-column justify-content-center">
                  <p class="mb-0 text-sm">{{ description }}</p>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import MaterialSelectedBadge from "@/components/common/MaterialSelectedBadge.vue";

export default {
  name: "StatusCard",
  components: {
    MaterialSelectedBadge,
  },
  props: {
    title: {
      type: String,
      default: "",
    },
    headers: {
      type: Array,
      required: true,
    },
    projects: {
      type: Array,
      required: true,
    },
    banner: {
      type: String,
      default: "",
    },
  },
  methods: {
    getStatusColor(status) {
      if (!status) return 'danger';
      
      const statusLower = status.toLowerCase();
      
      // Active, Enabled, Funded -> Green
      if (['active', 'enabled', 'executing', 'funded', 'ok'].includes(statusLower)) {
        return 'success';
      }
      
      // Idle, Low Balance -> Yellow/Amber
      if (['idle', 'low balance'].includes(statusLower)) {
        return 'warning';
      }
      
      // Default -> Red
      return 'danger';
    },
  },
};
</script>

<style scoped>
.status-column {
  min-width: 9rem;
}

.status-badge-wrap {
  width: 75%;
  min-width: 8rem;
}

:deep(.badge) {
  white-space: nowrap;
}
</style>
